$(function () {
    // init swup config
    /***************************

    swup

    ***************************/
    const options = {
        containers: ['#swupMain', '#swupMenu'],
        animateHistoryBrowsing: true,
        linkSelector: 'a:not([data-no-swup])',
        animationSelector: '[class="mil-main-transition"]',
        plugins: [
            new SwupPreloadPlugin(),
        ],
    };

    const swup = new Swup(options);

    $(document).on("init:all", function () {
        initAll();
    });

    // preloader length 0 run initAll
    if ($(".mil-preloader").length === 0) {
        initAll();
        $('body').css('overflow', 'auto');
    }

    function initAll() {
        ScrollTrigger.refresh();

        $(document).trigger("home:section:main");
        $(document).trigger("home:section:short-video");
        $(document).trigger("home:section:commercial-video");
        $(document).trigger("home:section:performance-marketing");
        $(document).trigger("home:section:product-branding");
        $(document).trigger("home:section:meet-our-client");
        $(document).trigger("short-video:section:short-video");
        $(document).trigger("short-video-detail:section:short-video-detail");
        $(document).trigger("performance-marketing:section:performance-marketing");
        $(document).trigger("performance-marketing-detail:section:performance-marketing-detail");
        $(document).trigger("commercial-video:section:commercial-video");
        $(document).trigger("product-branding:section:product-branding");
        $(document).trigger("product-branding-detail:section:product-branding-detail");
        $(document).trigger("about-us:section:banner");
        $(document).trigger("about-us:section:performance-highlights");
        $(document).trigger("about-us:section:how-it-works");
        $(document).trigger("contact-us:section:main");

        breadcrumbAnimation();

        if (swup.getCurrentUrl() === "/") {
            initHome();
        }

        globalFunction();
    }

    function globalFunction() {
        // SmoothScroll({
        //     frameRate: 150, // [Hz]
        //     animationTime: 1000, // [ms]
        //     stepSize: 80, // [px]

        //     // Pulse (less tweakable)
        //     // ratio of "tail" to "acceleration"
        //     pulseAlgorithm: true,
        //     pulseScale: 4,
        //     pulseNormalize: 1,

        //     // Acceleration
        //     accelerationDelta: 40, // 50
        //     accelerationMax: 3, // 3

        //     // Keyboard Settings
        //     keyboardSupport: true, // option
        //     arrowScroll: 50, // [px]

        //     // Other
        //     fixedBackground: true,
        //     excluded: ''
        // });

        // smoothScroll({
        //     easing: 'easeInOutCubic',
        //     duration: 1000
        // });

        // init btn zoom
        $(".btn-zoom").hover(function () {
            $(this).find(".mil-plus").remove();

            // add style svg bg #89aeca
            $(".mil-arrow").first().clone().css({
                "background": "#89aeca",
                "border-radius": "50%",
                "padding": "10px",
                "width": "30px",
                "height": "30px",
                "display": "flex",
                "justify-content": "center",
                "align-items": "center",
                "flex": "0 0 30px",
                "transition": "all 0.3s",
            }).appendTo(this);
        }, function () {
            $(this).find(".mil-arrow").remove();
            $(".mil-plus").first().clone().appendTo(this);
        });

        // swal from session laravel
        if (sessionStorage.getItem("swal")) {
            Swal.fire({
                icon: sessionStorage.getItem("swal"),
                title: sessionStorage.getItem("swal-title"),
                text: sessionStorage.getItem("swal-text"),
                confirmButtonText: "OK",
            });
            sessionStorage.clear();
        }
    }

    function breadcrumbAnimation() {
        // breadcrumb animation
        const breadcrumb = document.querySelectorAll(".mil-breadcrumbs");

        breadcrumb.forEach((section) => {
            let tl = gsap.timeline();

            // ignore right class
            if (section.classList.contains("right")) {
                tl.fromTo(section, {
                    "clip-path": "inset(0px -500% 0px 400%)",
                }, {
                    "clip-path": "inset(0% -500% 0% 0%)",
                    "opacity": 1,
                    duration: 1,
                    ease: 'sine',
                    scrollTrigger: {
                        trigger: section,
                        toggleActions: 'play none none reverse',
                    }
                })
            } else {
                // default for clip-path is inset(0px 400% 0px -200%)
                tl.fromTo(section, {
                    "clip-path": "inset(0px 400% 0px -500%)",
                }, {
                    "clip-path": "inset(0% 0% 0% -500%)",
                    "opacity": 1,
                    duration: 1,
                    ease: 'sine',
                    scrollTrigger: {
                        trigger: section,
                        toggleActions: 'play none none reverse',
                    }
                })
            }

        });
    }


    // page home
    function initHome() {
        const slideLeft = document.querySelectorAll(".mil-slide-left");

        slideLeft.forEach((section) => {
            gsap.fromTo(section, {
                x: -500,
                opacity: 0,
                ease: 'sine',
                scrollTrigger: {
                    trigger: section,
                },
            }, {
                x: 0,
                opacity: 1,
                duration: 1,
                scrollTrigger: {
                    trigger: section,
                    toggleActions: 'play none none reverse',
                },
            })
        });

        const slideRight = document.querySelectorAll(".mil-slide-right");

        let tl = null;

        slideRight.forEach((section, index) => {
            tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        toggleActions: 'play none none reverse',
                    },
                })
                .fromTo(section, {
                    x: 500,
                    opacity: 0,
                    ease: 'sine',
                }, {
                    x: 0,
                    opacity: 1,
                    duration: 1,
                })

            tl.add('progress-0-' + index, ">");

            const jsSwiperBottom = document.querySelectorAll('.js-swiper-bottom');

            tl.fromTo(jsSwiperBottom[index], {
                '--before-translate-y': '300%',
                '--before-opacity': 0,
                ease: 'linear',
            }, {
                '--before-translate-y': '-50%',
                '--before-opacity': 1,
                duration: 0.02,
            }, "progress-0-" + index);

            tl.add("progress-1-" + index, ">+=0.5");

            tl.fromTo(jsSwiperBottom[index], {
                // custom css properties root
                '--before-width': '70px',
                '--before-border-radius': '50px',
                // delay opacity
                // ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                ease: 'linear',
            }, {
                '--before-width': '100%',
                '--before-border-radius': '50px',
                duration: 0.02,
            }, "progress-1-" + index);

            tl.add("progress-2-" + index, ">+=0.5");

            tl.fromTo(jsSwiperBottom[index], {
                '--before-opacity': 1,
                ease: 'linear',
            }, {
                '--before-opacity': 0,
                duration: 0.2,
            }, "progress-2-" + index);

            tl.add("progress-3-" + index, ">-=0.5");

            tl.fromTo(jsSwiperBottom[index], {

                '--item-left-transform': 'translateX(500px)',
                '--item-right-transform': 'translateX(-500px)',
                '--item-pointer-events': 'none',
                ease: 'cubic-bezier(.15,.65,.47,.04)',
            }, {

                '--item-left-transform': 'translateX(0)',
                '--item-right-transform': 'translateX(0)',
                '--item-pointer-events': 'auto',
                duration: 0.5,
            }, "progress-3-" + index);

            tl.add("progress-4-" + index, ">-=0.2");

            tl.fromTo(jsSwiperBottom[index], {
                '--item-opacity': 0,
                ease: 'linear',
            }, {
                '--item-opacity': 1,
                duration: 0.5,
            }, "progress-4-" + index);
        });
    }

    $(document).on("swup:visit:end", function () {
        initAll();
    });
});

$(document).on("swup:content:replace", function () {
    // init btn zoom
    document.body.style.overflow = "auto";
});
